import { render, staticRenderFns } from "./GuidelineRecorder.vue?vue&type=template&id=f2d33692&scoped=true&"
import script from "./GuidelineRecorder.vue?vue&type=script&lang=ts&"
export * from "./GuidelineRecorder.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineRecorder.vue?vue&type=style&index=0&id=f2d33692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d33692",
  null
  
)

export default component.exports